import { setInValidUser } from "../authActions/authAction";
import {
  FAIL_REQUEST,
  MAKE_REQUEST,
  GET_ACTION_LIST,
  SET_REQUEST_FOR_REASSIGN,
  UPDATE_FETCH_ACTION_LIST_STATUS,
  SET_SINGLE_ACTION_DETAILS,
  SET_UPDATE_IS_COMPLETE_RESPONSE,
  SET_ACTION_ACTIVITIES_DETAILS,
  UPDATE_ISSUCCESS,
  SET_CANCEL_ACTION_RESPONSE,
  SET_ACTION_LIST_FOR_CHART,
  SET_USER_TOTAL_DUE_ACTION_PRIORITY_WISE,
  MAKE_UPDATE_REQUEST,
  SET_SUCCESS,
  SET_ACTION_DATA,
  SET_MEETING_CHART,
  SET_ATTENDEE_CHART,
  SET_MEETING_CHART_AND_ATTENDEE_CHART,
  CARD_CLICK_TYPE,
  SET_HIDE_MY_TASK_BUTTON,
  CHART_CLICK_TYPE,
  RE_ASSIGN_TYPE,
  SET_ISCHECKED_REQUIRED,
  FILTER_CLICK
} from "./actionTypes";
import axios from "axios";
import { toast } from "react-toastify";
import { viewParentMeeting } from "../meetingActions/MeetingAction";
import { handleApiError } from "../../../helpers/errorResponseHelper";
import { viewSingleUser } from "../userAction/userAction";

export const makeRequest = (data) => {
  return {
    type: MAKE_REQUEST,
    payload: data,
  };
};

export const failRequest = (err) => {
  return {
    type: FAIL_REQUEST,
    payload: err,
  };
};

export const setIsCheckRequired = (value) => {
  return {
    type: SET_ISCHECKED_REQUIRED,
    payload: value,
  };
};

// export const fetchActionList = (payload, accessToken) => {
//   return (dispatch) => {
//     if (!payload.accessToken) {
//       console.warn("Access token is missing");
//       return;
//     }
//     dispatch(makeRequest());
//     const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/viewUserAllActions`;
//     const headerObject = {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: payload.accessToken,
//         "Cache-Control": "no-cache",
//         Pragma: "no-cache", // For compatibility with older HTTP/1.0 servers
//         Expires: "0", // Force response to expire immediately
//       },
//       params: {
//         limit: payload.limit,
//         page: payload.page,
//         order: payload.order,
//       },
//     };
//     const bodyPayload = {
//       actionStatus: payload.actionStatus ? payload.actionStatus : undefined,
//       delayStatus: payload.delayStatus ? payload.delayStatus : undefined,
//       createdById: payload.createdById ? payload.createdById : undefined,
//       organizationId: payload.organizationId,
//       meetingId: payload.meetingId,
//       searchKey: payload.searchKey ? payload.searchKey : undefined,
//       toDate: payload.toDate ? payload.toDate : undefined,
//       fromDate: payload.fromDate ? payload.fromDate : undefined,
//       assignedUserId:
//         payload?.assignedUserId !== "" ? payload?.assignedUserId : undefined,
//     };

//     axios
//       .post(webApiUrl, bodyPayload, headerObject)
//       .then((result) => {
//         const resData = result.data;

//         if (resData.data?.isInValidUser) {
//           dispatch(setInValidUser(true));
//         }

//         dispatch(getActionList(resData));
//       })
//       .catch((err) => {
//         dispatch(failRequest(err.message));

//         if (handleApiError(err)) return;
//       });
//   };
// };
export const setFilterClick = (value) => {
  return {
    type: FILTER_CLICK,
    payload: value,
  };
};

export const fetchActionList = (payload, accessToken) => {
  return (dispatch, getState) => {
    if (!payload.accessToken) {
      console.warn("Access token is missing");
      return;
    }

    dispatch(makeRequest());

    // 👇 Log full redux state
    const state = getState();
    console.log("Redux state in fetchActionList:", state);
    dispatch(setCardClickType(null));
      dispatch(setCardClickType("FILTER"));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/viewUserAllActions`;

    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: payload.accessToken,
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
      params: {
        limit: payload.limit,
        page: payload.page,
        order: payload.order,
      },
    };

    const bodyPayload = {
      actionStatus: payload.actionStatus || undefined,
      delayStatus: payload.delayStatus || undefined,
      createdById: payload.createdById || undefined,
      organizationId: payload.organizationId,
      meetingId: payload.meetingId,
      searchKey: payload.searchKey || undefined,
      toDate: payload.toDate || undefined,
      fromDate: payload.fromDate || undefined,
      assignedUserId:
        payload?.assignedUserId !== "" ? payload?.assignedUserId : undefined,
    };

    axios
      .post(webApiUrl, bodyPayload, headerObject)
      .then((result) => {
        const resData = result.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
        }

        dispatch(getActionList(resData));
//  dispatch(setCardClickType(null));
       
      })
      .catch((err) => {
        dispatch(failRequest(err.message));

        if (handleApiError(err)) return;
      });
  };
};



export const fetchActionListNew = (payload, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    //  dispatch(setCardClickType("MY_TASK"));
    dispatch(hidemytaskButton(false));
    dispatch(makeRequest());
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/viewUserAllActions`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
        "Cache-Control": "no-cache",
        Pragma: "no-cache", // For compatibility with older HTTP/1.0 servers
        Expires: "0", // Force response to expire immediately
      },
      params: {
        limit: payload.limit,
        page: payload.page,
        order: payload.order,
      },
    };

    const bodyPayload = {
      organizationId: payload.organizationId,
      searchKey: payload.searchKey ? payload.searchKey : undefined,
      assignedUserId:
        payload?.assignedUserId !== "" ? payload?.assignedUserId : undefined,
    };

    axios
      .post(webApiUrl, bodyPayload, headerObject)
      .then((result) => {
        const resData = result.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
        }

        dispatch(getActionList(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
      });
  };
};

export const fetchActionListOwn = (payload, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest());
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/viewUserAllActions`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
        "Cache-Control": "no-cache",
        Pragma: "no-cache", // For compatibility with older HTTP/1.0 servers
        Expires: "0", // Force response to expire immediately
      },
      params: {
        limit: payload.limit,
        page: payload.page,
        order: payload.order,
      },
    };

    axios
      .post(webApiUrl, payload, headerObject)
      .then((result) => {
        const resData = result.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
        }

        dispatch(getActionList(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
      });
  };
};

export const getActionList = (data) => {
  return {
    type: GET_ACTION_LIST,
    payload: data,
  };
};

export const processRequestForReassign = (actionId, payload, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest(null));
    dispatch(setIsSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/actionReAssignRequest/${actionId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    return axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(updateActionListStatus(true));
          dispatch(fetchSingleAction(actionId, accessToken));
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          dispatch(updateActionListStatus(false));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        return resData;
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        dispatch(updateActionListStatus(false));
        if (handleApiError(err)) return;
      });
  };
};

export const setRequestForReassign = (data) => {
  return {
    type: SET_REQUEST_FOR_REASSIGN,
    payload: data,
  };
};

export const updateActionListStatus = (data) => {
  return {
    type: UPDATE_FETCH_ACTION_LIST_STATUS,
    payload: data,
  };
};

export const reassignType = (data) => {
  return {
    type: RE_ASSIGN_TYPE,
    payload: data,
  };
};

export const processReassign = (actionId, payload, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeUpdateRequest(true));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/reAssignAction/${actionId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    const bodyPayload = {
      organizationId: payload.organizationId,
      assignedUsers: payload.assignedUsers,
      reAssignReason: payload.reAssignReason,
      dueDate: payload.dueDate ? payload.dueDate : undefined,
      priority: payload.priority,
      lastActionActivityId: payload.lastActionActivityId
        ? payload.lastActionActivityId
        : undefined,
      ...(payload.isAcceptedClick !== undefined && {
        isAcceptedClick: payload.isAcceptedClick,
        requestedId: payload.requestedId,
      }),
    };

    return axios
      .put(webApiUrl, bodyPayload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(updateActionListStatus(true));
          dispatch(fetchSingleAction(actionId, accessToken));
          // if()
          dispatch(getactionActivitiesDetails(actionId, accessToken));
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          dispatch(setIsSuccess(true));
          dispatch(makeUpdateRequest(false));
          return { status: true };
        } else {
          dispatch(updateActionListStatus(false));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          dispatch(makeUpdateRequest(false));
        }
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        dispatch(makeUpdateRequest(false));
        dispatch(updateActionListStatus(false));
        if (handleApiError(err)) return;
      });
  };
};

export const fetchSingleAction = (actionId, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      //alert("Access token is missing")
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest());
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/viewSingleAction/${actionId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    return axios
      .get(webApiUrl, headerObject)
      .then((result) => {
        const resData = result.data;
        console.log("resData", resData);
        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
        }
        if (!resData.success && !resData.data?.isInValidUser) {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }

        // dispatch(setSingleActionDetails({ data: resData.data, actionId }));
        if (resData.success) {
          if (resData.data?.resetOrgId) {
            const { token, userData } = resData?.data?.authResult;
            localStorage.setItem("accessToken", token);
            localStorage.setItem("userData", JSON.stringify(userData));
            dispatch(setSingleActionDetails({ data: resData.data, actionId }));
            dispatch(viewSingleUser(userData._id, token));
            return { isReload: true };
          }
          dispatch(setSingleActionDetails({ data: resData.data, actionId }));
          return { isReload: false };
        }
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
      });
  };
};

export const setSingleActionDetails = (data) => {
  return {
    type: SET_SINGLE_ACTION_DETAILS,
    payload: data,
  };
};

export const setIsSuccess = (data) => {
  return {
    type: UPDATE_ISSUCCESS,
    payload: data,
  };
};

export const makeUpdateRequest = (value) => {
  return {
    type: MAKE_UPDATE_REQUEST,
    payload: value,
  };
};

export const updateIsComplete = (actionId, payload, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest(null));
    dispatch(setIsSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/updateAction/${actionId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    return axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(fetchSingleAction(actionId, accessToken));

          dispatch(setUpdateIsCompleteResponse(resData));
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        return resData;
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
      });
  };
};

export const setUpdateIsCompleteResponse = (data) => {
  return {
    type: SET_UPDATE_IS_COMPLETE_RESPONSE,
    payload: data,
  };
};

export const getactionActivitiesDetails = (actionId, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest());
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/viewActionActivities/${actionId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .get(webApiUrl, headerObject)
      .then((result) => {
        const resData = result.data;
        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
        }
        if (resData.success) {
          dispatch(setactionActivitiesDetails(resData));
        } else {
          dispatch(setactionActivitiesDetails(resData));
        }
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
      });
  };
};

export const setactionActivitiesDetails = (data) => {
  return {
    type: SET_ACTION_ACTIVITIES_DETAILS,
    payload: data,
  };
};

export const reopenAction = (meetingId, actionId, payload, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest(null));
    dispatch(setIsSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/reopenAction/${actionId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(setIsSuccess(true));

          dispatch(viewParentMeeting(meetingId, accessToken));

          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
      });
  };
};

export const reopenActionInLastMinuteActions = (
  meetingId,
  actionId,
  payload,
  accessToken
) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }

    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/reopenAction/${actionId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    return axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          return { status: true };
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          return { status: false };
        }
      })
      .catch((err) => {
        if (handleApiError(err)) return;
      });
  };
};

export const approveActionInLastMinuteActions = (
  meetingId,
  actionId,
  payload,
  accessToken
) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }

    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/approveAction/${actionId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    return axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          return { status: true };
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          return { status: false };
        }
      })
      .catch((err) => {
        if (handleApiError(err)) return;
      });
  };
};

export const approveAction = (meetingId, actionId, payload, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest(null));
    dispatch(setIsSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/approveAction/${actionId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(setIsSuccess(true));
          dispatch(viewParentMeeting(meetingId, accessToken));

          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
      });
  };
};

export const rejectReassignRequest = (actionId, payload, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest(null));
    dispatch(setIsSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/rejectReasignRequest/${actionId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(fetchSingleAction(actionId, accessToken));

          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          dispatch(setIsSuccess(true));
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
      });
  };
};

export const cancelAction = (meetingId, actionId, accessToken, payload) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(setIsSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/cancelAction/${actionId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };
    dispatch(makeUpdateRequest(true));
    axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(setCancelActionResponse(resData));
          dispatch(makeUpdateRequest(false));
          dispatch(viewParentMeeting(meetingId, accessToken));

          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          dispatch(setIsSuccess(true));
        } else {
          dispatch(setCancelActionResponse(resData));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          dispatch(makeUpdateRequest(false));
        }
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        dispatch(makeUpdateRequest(false));
        if (handleApiError(err)) return;
      });
  };
};

export const cancelActionForActionDetails = (
  actionId,
  accessToken,
  payload
) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }

    dispatch(setIsSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/cancelAction/${actionId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };
    dispatch(makeUpdateRequest(true));
    return axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(setCancelActionResponse(resData));
          dispatch(makeUpdateRequest(false));
          // dispatch(ViewActionDetails(actionId))
          dispatch(fetchSingleAction(actionId, accessToken));
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          dispatch(setIsSuccess(true));
          return { status: true };
        } else {
          dispatch(setCancelActionResponse(resData));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          dispatch(makeUpdateRequest(false));
          return { status: false };
        }
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        dispatch(makeUpdateRequest(false));
        console.log("CAT PART ERROR->", err.message);
        if (handleApiError(err)) return;
      });
  };
};

export const cancelLastMeetingAction = (
  meetingId,
  actionId,
  accessToken,
  payload
) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }

    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/cancelAction/${actionId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };
    //  dispatch(makeUpdateRequest(true));
    return axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          //   dispatch(setCancelActionResponse(resData));
          //  dispatch(makeUpdateRequest(false));
          //dispatch(viewParentMeeting(meetingId, accessToken));

          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          return { status: true };
          //  dispatch(setIsSuccess(true));
        } else {
          //  dispatch(setCancelActionResponse(resData));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          //  dispatch(makeUpdateRequest(false));
        }
      })
      .catch((err) => {
        // dispatch(failRequest(err.message));
        //  dispatch(makeUpdateRequest(false));
        if (handleApiError(err)) return;
      });
  };
};

export const cancelActionInList = (
  meetingId,
  actionId,
  accessToken,
  payload
) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    // dispatch(setIsSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/cancelAction/${actionId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };
    //  dispatch(makeUpdateRequest(true));
    return axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(setCancelActionResponse(resData));
          // dispatch(setIsSuccess(true));
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          return { status: true };
        } else {
          dispatch(setCancelActionResponse(resData));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        // dispatch(makeUpdateRequest(false));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
      });
  };
};

export const setCancelActionResponse = (data) => {
  return {
    type: SET_CANCEL_ACTION_RESPONSE,
    payload: data,
  };
};

export const getActionListForChart = (organizationId, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest());
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/totalActionList/${organizationId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .get(webApiUrl, headerObject)
      .then((result) => {
        const resData = result.data;
        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
        }

        dispatch(setActionListForChart(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
      });
  };
};

export const setActionListForChart = (data) => {
  return {
    type: SET_ACTION_LIST_FOR_CHART,
    payload: data,
  };
};

export const getUserActionPriotityDetails = (payload, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/getUserActionPriotityDetails`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
      params: {
        limit: payload.limit,
        page: payload.page,
        order: payload.order,
      },
    };

    const bodyPayload = {
      organizationId: payload.organizationId,
      searchKey: payload?.searchKey ? payload?.searchKey : undefined,
    };
    axios
      .post(webApiUrl, bodyPayload, headerObject)
      .then((result) => {
        const resData = result.data;
        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
        }
        dispatch(setUserTotalDueActionPriorityWise(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
      });
  };
};

export const setUserTotalDueActionPriorityWise = (data) => {
  return {
    type: SET_USER_TOTAL_DUE_ACTION_PRIORITY_WISE,
    payload: data,
  };
};

export const sendActionNotification = (payload, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }

    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/sendActionNotification`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    return axios
      .post(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
        }
        if (resData.success) {
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          dispatch(makeUpdateRequest(false));
          return { status: true };
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          dispatch(makeUpdateRequest(false));
          return { status: false };
        }
      })
      .catch((err) => {
        dispatch(makeUpdateRequest(false));
        // dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
      });
  };
};

export const setSuccess = (data) => {
  return {
    type: SET_SUCCESS,
    payload: data,
  };
};
export const setMeetingActionChart = (data) => {
  console.log(data);
  return {
    type: SET_MEETING_CHART,
    payload: data,
  };
};

export const setAttendeeActionChart = (data) => {
  return {
    type: SET_ATTENDEE_CHART,
    payload: data,
  };
};

// PRATISHRUTI ADD
export const setAttendeeAndMeetingChartFalse = (data) => {
  return {
    type: SET_MEETING_CHART_AND_ATTENDEE_CHART,
    payload: data,
  };
};

export const handlePendingCardClick = (payload, accessToken) => {
  return async (dispatch) => {
    try {
      dispatch(setCardClickType("TOTAL_PENDING"));

      dispatch(makeRequest());

      // Construct query parameters
      const queryParams = new URLSearchParams({
        limit: payload.limit || 10,
        page: payload.page || 1,
        order: payload.order || "desc",
      }).toString();

      const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/viewUserAllActions?${queryParams}`;

      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      };

      const bodyPayload = {
        actionStatus: payload?.actionStatus || undefined,
        delayStatus: payload?.delayStatus || undefined,
        createdById: payload?.createdById || undefined,
        organizationId: payload.organizationId,
        meetingId: payload?.meetingId || undefined,
        searchKey: payload?.searchKey || undefined,
        toDate: payload?.toDate || undefined,
        fromDate: payload?.fromDate || undefined,
        assignedUserId: payload?.assignedUserId || undefined,
      };

      const response = await axios.post(webApiUrl, bodyPayload, headerObject);

      const resData = response.data;

      if (!resData.success || resData.data?.isInValidUser) {
        toast.error(resData.message || "Failed to fetch actions", {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
      }

      dispatch(getActionList(resData));
      // dispatch(setCardClickType(null));
    } catch (error) {
      console.error("Error fetching data:", error.message);
      dispatch(failRequest(error.message));

      toast.error(
        error.message || "Error fetching data, please try again later.",
        {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        }
      );
    }
  };
};

// actions/uiActions.js or actions/commonActions.js
export const setCardClickType = (type) => ({
  type: CARD_CLICK_TYPE,
  payload: type,
});

export const hidemytaskButton = (type) => ({
  type: SET_HIDE_MY_TASK_BUTTON,
  payload: type,
});

export const handlePriorityCardClick = (payload, accessToken) => {
  return async (dispatch) => {
    try {
      dispatch(setCardClickType("PENDING"));
      dispatch(hidemytaskButton(true));
      dispatch(makeRequest());

      const queryParams = new URLSearchParams({
        limit: payload.limit || 10,
        page: payload.page || 1,
        order: payload.order || "desc",
      }).toString();

      const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/getAllActions?${queryParams}`;

      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      };

      const validPriorities = ["HIGH", "LOW", "NORMAL"];
      const priority =
        payload?.priority &&
        validPriorities.includes(payload.priority.toUpperCase())
          ? payload.priority.toUpperCase()
          : "NORMAL";

      const bodyPayload = {
        actionStatus: payload?.actionStatus || undefined,
        delayStatus: payload?.delayStatus || undefined,
        createdById: payload?.createdById || undefined,
        organizationId: payload.organizationId,
        meetingId: payload?.meetingId || undefined,
        searchKey: payload?.searchKey || undefined,
        toDate: payload?.toDate || undefined,
        fromDate: payload?.fromDate || undefined,
        //assignedUserId: payload?.assignedUserId || undefined,
        priority: priority,
      };

      const response = await axios.post(webApiUrl, bodyPayload, headerObject);

      const resData = response.data;

      if (!resData.success || resData.data?.isInValidUser) {
        toast.error(resData.message || "Failed to fetch actions", {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
        return;
      }
      dispatch(getActionList(resData));
      
        // dispatch(setCardClickType(null));
    } catch (error) {
      console.error("Error fetching data:", error.message);
      dispatch(failRequest(error.message));

      toast.error(
        error.message || "Error fetching data, please try again later.",
        {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        }
      );
    }
  };
};

export const setActionList = (data) => {
  return {
    type: SET_ACTION_DATA,
    payload: data,
  };
};

// PRATISHRUTI ADD THIS CODE FOR RECHARTS BAR CLICK//
export const setChartClickType = (type) => ({
  type: CHART_CLICK_TYPE,
  payload: type,
});

export const rechartsAllData = (payload, accessToken) => {
  return (dispatch) => {
    dispatch(makeUpdateRequest(true));
    dispatch(setCardClickType("MEETING"));

    dispatch(hidemytaskButton(true));
    const queryParams = new URLSearchParams({
      limit: payload.limit || 10,
      page: payload.page || 1,
      order: payload.order || "desc",
    }).toString();

    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/prioritywiseactionduelist?${queryParams}`;

    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    };

    const bodyPayload = {
      organizationId: payload.organizationId.trim(),
      searchKey: payload?.searchKey || undefined,
      meetingId: payload?.meetingId || undefined,
      actionStatus: "PENDING",
    };

    return axios
      .post(webApiUrl, bodyPayload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData?.data?.isInValidUser) {
          dispatch(setInValidUser(true));
        } else {
          dispatch(setInValidUser(false));
        }
        if (resData?.success) {
          dispatch(
            setMeetingActionChart({
              status: true,
              clickedMeetingId: payload?.meetingId,
            })
          );

          dispatch(setActionList(resData.data));
  // dispatch(setCardClickType(null));
          dispatch(makeUpdateRequest(false));
          return { status: true };
        } else {
          dispatch(makeUpdateRequest(false));
          return { status: false };
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        dispatch(failRequest(err.message));
        dispatch(makeUpdateRequest(false));

        toast.error("An error occurred while fetching meeting chart data.", {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };
};

export const rechartsAttendeeData = (payload, accessToken) => {
  return (dispatch) => {
    dispatch(hidemytaskButton(true));
    dispatch(makeUpdateRequest(true));

    dispatch(setCardClickType("ATTENDEE"));

    // Construct the web API URL
    const queryParams = new URLSearchParams({
      limit: payload.limit || 10,
      page: payload.page || 1,
      order: payload.order || "desc",
    }).toString();

    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/attendeeprioritywiseactionduelist?${queryParams}`;

    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    };

    const bodyPayload = {
      organizationId: payload.organizationId.trim(),
      searchKey: payload?.searchKey || undefined,
      assignedUserId: payload?.assignedUserId || undefined,
    };

    return axios
      .post(webApiUrl, bodyPayload, headerObject)
      .then((res) => {
        const resData = res.data;
        if (resData?.data?.isInValidUser) {
          dispatch(setInValidUser(true));
        } else {
          dispatch(setInValidUser(false));
        }
        if (resData?.success) {
          dispatch(
            setAttendeeActionChart({
              status: true,
              assignedUserId: payload.assignedUserId,
            })
          );
          dispatch(setActionList(resData.data));
          //dispatch(setCardClickType(null));
          dispatch(makeUpdateRequest(false));
          return { status: true };
        } else {
          dispatch(makeUpdateRequest(false));
          return { status: false };
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        dispatch(failRequest(err.message));
        dispatch(makeUpdateRequest(false));

        toast.error("An error occurred while fetching meeting chart data.", {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };
};

export const totalPriorityCardClick = (payload, accessToken) => {
  return async (dispatch) => {
    try {
      dispatch(setCardClickType("PRIORITY"));
      dispatch(hidemytaskButton(true));
      dispatch(makeRequest());

      const queryParams = new URLSearchParams({
        limit: payload.limit || 10,
        page: payload.page || 1,
        order: payload.order || "desc",
      }).toString();

      const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/allprioriywisedta?${queryParams}`;

      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      };

      const validPriorities = ["HIGH", "LOW", "NORMAL"];
      const priority =
        payload?.priority &&
        validPriorities.includes(payload.priority.toUpperCase())
          ? payload.priority.toUpperCase()
          : "NORMAL";

      const bodyPayload = {
        actionStatus: payload?.actionStatus || undefined,
        delayStatus: payload?.delayStatus || undefined,
        createdById: payload?.createdById || undefined,
        organizationId: payload.organizationId,
        meetingId: payload?.meetingId || undefined,
        searchKey: payload?.searchKey || undefined,
        toDate: payload?.toDate || undefined,
        fromDate: payload?.fromDate || undefined,
        assignedUserId: payload?.assignedUserId || undefined,
        priority: priority,
      };

      const response = await axios.post(webApiUrl, bodyPayload, headerObject);
      const resData = response.data;

      if (!resData.success || resData.data?.isInValidUser) {
        toast.error(resData.message || "Failed to fetch actions", {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
        return;
      }

      const filteredData = resData;

      const finalPayload = {
        data: filteredData,
        totalCount: filteredData.length,
      };

      dispatch(getActionList(resData));
      // dispatch(setCardClickType(null));
    } catch (error) {
      console.error("Error fetching data:", error.message);
      dispatch(failRequest(error.message));

      toast.error(
        error.message || "Error fetching data, please try again later.",
        {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        }
      );
    }
  };
};
